module.exports = __webpack_public_path__ + "static/media/KamalAmin.c8c44946.png";